import type { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Sheet } from '../index';

import { useTheme } from './theme';

// Scale-switch window (D2-S5, 2026-05-29). Opened from the effort-meter label
// (FocusPanelEffort, AP-0b) — also auto-opened once on the very first meter
// tap (effortMeterIntro) so the band explains itself when first used.
// A bottom sheet that REUSES the host's EffortScalePicker (the v2.39.0
// RIR↔RPE preference control, injected — RW-18: it owns its own
// get-merge-PATCH round-trip against the host's Profile, which the shared
// tree cannot reach itself) — no duplicate persistence. Picking a scale
// updates Profile.effortScale, which re-renders the logger so every row's
// effort field shows the converted mirror live (the SetRow display derives
// the inactive scale, so nothing blanks). Sheet chrome (scrim, rounded-top,
// ✕ close, safe-area bottom) comes from the shared <Sheet>.
export function EffortScaleModal({
  visible,
  onClose,
  EffortScalePicker,
}: {
  visible: boolean;
  onClose: () => void;
  EffortScalePicker: ComponentType<Record<string, never>>;
}) {
  const theme = useTheme();
  const { t } = useTranslation();
  const insets = useSafeAreaInsets();
  return (
    <Sheet
      theme={theme}
      visible={visible}
      onRequestClose={onClose}
      title={t('mobile.effortSettings.title', { defaultValue: 'Effort' })}
      onClose={onClose}
      closeAccessibilityLabel={t('mobile.common.close', { defaultValue: 'Close' })}
      bottomInset={insets.bottom}
    >
      <EffortScalePicker />
    </Sheet>
  );
}
